// IDs of DOM elements
var videoLink = '.watch-video-button';
var closeLink = '#close-video';
var _footer = $('.site-footer');  
var played = false;
var isMobile = window.matchMedia("only screen and (max-width: 768px)");


// Main Miku Function.
var init = function() {
  // Define our function variables
  var nav = $('#shopify-section-header'); // nav div
  var nav_class = 'mini-nav'; // Class name
  var header = $('.site-header'); // header div
  var logo_white = $('#miku-white-logo');
  var logo_black = $('#miku-black-logo');  
  var logo_class = 'miku-care-logo-scroll'
  var threshold = 40; // pixels scrolled
  var mobile_hamburger = $('.site-header__menu');
  var promo = $('.promo-text');
  
  var last_known_scroll_position = 0;
  var ticking = false;  
  var tickingTech = false;
  var mainContentValue = parseInt($('.main-content').css('paddingTop'), 10);
  
  // Variable for toggling on/off animations
  window.mobilecheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }; 
  
  if (isMobile.matches) {
    $('.main-content').css('paddingTop', mainContentValue + 'px')
  }  
  
  // ID.me access token, Validates user is miliatry or first responder. 
  try {
    var par = window.location.hash.split("&")[0]
    if (par) {

      var token = par.match(/[^#access_token=]\w+/)[0];
      var parameters = {
        url      : "https://api.id.me/api/public/v3/attributes.json?access_token=" + token,
        dataType : "jsonp"
      };

      var payload = $.get(parameters).done(function(response) {
        payload = response;

        if (payload.status[0].verified) {
          console.log("ID.me User verified!")
        }
      });  
    }
  }
  catch(err) {
  	console.log(err)
  }

  
  // Applies drop shadow and background color to nav bar on scroll event if we are on the home page
  if  ( window.location.pathname == '/' 
      || window.location.pathname == '/pages/technology'
      || window.location.pathname == '/pages/specs'
      || window.location.pathname == '/products/miku-baby-monitor') {

      // Plays hero video if we are on overview page
//       if (window.location.pathname == '/' ) {
//         var heroVideo = document.getElementById("heroVideo");
//         heroVideo.play()   
        
//       }
      
      window.addEventListener('scroll', function(e) {
        last_known_scroll_position_overview = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(function() {
            overviewScroll(last_known_scroll_position_overview)
            ticking = false;
          });
          ticking = true;
        }
      });      
      
      function overviewScroll(last_known_scroll_position_overview) { 
		var distance = last_known_scroll_position_overview;
        if (distance > threshold) { // If scrolled past threshold
          nav.addClass(nav_class); // Add class to nav
        } else { // If user scrolls back to top
          if (nav.hasClass(nav_class)) { // And if class has been added            
            nav.removeClass(nav_class) // Remove it
          }
          if (header.hasClass('miku-scroll-nav')) {
            header.removeClass('miku-scroll-nav');
          }      
      	} 
      }
    
  	}

  
    // Promo top bar, close button.
  $('.promo-close-btn').on("click touchstart", function(e) {
    $('.main-content').css('paddingTop', mainContentValue + 'px')
    $('.promo-text').css('display', 'none');
    $('.promo-text').addClass('promo-closed')
    
    if (isMobile.matches) {
    	$('#shopify-section-1525304605325').css('margin-top', '-40px');
        $('.product-single__photo').css('margin-top', 'unset');
    }
    
    if (window.location.pathname == '/pages/specs') {
      $('.main-content').css({"padding-top": '70px'})
    }
    
    if (isMobile.matches) {
      if (window.location.pathname == '/products/miku-baby-monitor') {
      	$('.product-template__container').css({"margin-top": '70px'})
      }
      if (window.location.pathname == '/pages/technology') {
      	$('.features-hero-text').css({"margin-top": 'unset'})
      }
      
      if (window.location.pathname == '/pages/specs') {
        $('.main-content').css({"padding-top": '66px'})

      }      
      
    }
    else {
      if (window.location.pathname == '/products/miku-baby-monitor') {
      	$('.product-form').css({"margin-top": '30px'})
      } 
    }
    
    
  })
  
  
  if (!window.mobilecheck) {
    // Baby List Button     
    $(".baby-list-btn").hover(function(){
      $('.baby-list-btn').addClass('baby-list-btn-active')
      $('#baby-list-icon').attr('src','https://cdn.shopify.com/s/files/1/2621/9254/files/plus-white.svg?15682878173783970092');    
      $('.baby-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    },function(){
        $('.baby-list-btn').removeClass('baby-list-btn-active')
        $('#baby-list-icon').attr('src', 'https://cdn.shopify.com/s/files/1/2621/9254/files/plus-grey.svg?12082759771878767215');        
        $('.baby-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    });


    $(".baby-list-list").hover(function(){
      $('.baby-list-btn').addClass('baby-list-btn-active')    
      $('#baby-list-icon').attr('src','https://cdn.shopify.com/s/files/1/2621/9254/files/plus-white.svg?15682878173783970092');    
      $('.baby-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    },function(){
        $('.baby-list-btn').removeClass('baby-list-btn-active')
        $('#baby-list-icon').attr('src', 'https://cdn.shopify.com/s/files/1/2621/9254/files/plus-grey.svg?12082759771878767215');
        $('.baby-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    });
    
    // Share List Button
    $(".share-list-btn").hover(function(){
      $('.share-list-btn').addClass('share-list-btn-active')
      $('#share-list-icon').attr('src','https://cdn.shopify.com/s/files/1/2621/9254/files/share-blue.svg?12082759771878767215');    
      $('.share-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    },function(){
        $('.share-list-btn').removeClass('share-list-btn-active')
        $('#share-list-icon').attr('src', 'https://cdn.shopify.com/s/files/1/2621/9254/files/share-grey.svg?12082759771878767215');        
        $('.share-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    });


    $(".share-list-list").hover(function(){
      $('.share-list-btn').addClass('share-list-btn-active')    
      $('#share-list-icon').attr('src','https://cdn.shopify.com/s/files/1/2621/9254/files/share-blue.svg?12082759771878767215');    
      $('.share-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    },function(){
        $('.share-list-btn').removeClass('share-list-btn-active')
        $('#share-list-icon').attr('src', 'https://cdn.shopify.com/s/files/1/2621/9254/files/share-grey.svg?12082759771878767215');
        $('.share-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
    });
        
  }
 

  // Product page hide baby list button click 
  $(".baby-list-btn").on('click', function( event ) {
    // hide 
    if ($('.baby-list-btn').hasClass('baby-list-btn-active')) {

       $('.baby-list-btn').removeClass('baby-list-btn-active')
       $('#baby-list-icon').attr('src', 'https://cdn.shopify.com/s/files/1/2621/9254/files/plus-grey.svg?12082759771878767215');
       $('.baby-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');     
    }
    else {
      $('.baby-list-btn').addClass('baby-list-btn-active')
      $('#baby-list-icon').attr('src','https://cdn.shopify.com/s/files/1/2621/9254/files/plus-white.svg?15682878173783970092');    
      $('.baby-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
      
    }
  }); 
  
  // Product page hide share list button click 
  $(".share-list-btn").on('click', function( event ) {
    // hide 
    if ($('.share-list-btn').hasClass('share-list-btn-active')) {

       $('.share-list-btn').removeClass('share-list-btn-active')
       $('#share-list-icon').attr('src', 'https://cdn.shopify.com/s/files/1/2621/9254/files/share-grey.svg?12082759771878767215');
       $('.share-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');      
    }
    else {
      $('.share-list-btn').addClass('share-list-btn-active')
      $('#share-list-icon').attr('src','https://cdn.shopify.com/s/files/1/2621/9254/files/share-blue.svg?12082759771878767215');    
      $('.share-list-list').animate({ height: 'toggle', opacity: 'toggle' }, 'medium');
      
    }
  });   
 
  // if email TD is clicked, fire event
  var table = $("#share-list-table");
  table.on("click", ".share-list-em-td", function( event ) {
    window.open(`mailto:?subject=&body=${window.location.href}`,'popup','width=600,height=600');
  });
  
  table.on("click", ".share-list-fb-td", function( event ) {
  	window.open(`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fmikucare.com%2Fproducts%2F${window.location.href.substring(window.location.href.lastIndexOf('/') + 1)}&amp;src=sdkpreparse`,'popup','width=600,height=600');
    return false;
  });  
  
  table.on("click", ".share-list-tw-td", function( event ) {
  	window.open(`https://twitter.com/intent/tweet?text=${window.location.href}`,'popup','width=600,height=600'); 
    return false;
  });  
  
  table.on("click", ".share-list-cp-td", function( event ) {
    
	copyReferralLink(null, '#product-copy-text', `${window.location.href}`)    
    
    return false;
  });
   
 
  // TODO: remove this if we don't need it... 
  // We will most likely use this for callback from Chargify
  
  // Landing Page. Gets URL parameters and show message. 
  var urlParams;
  (window.onpopstate = function () {
      var match,
          pl     = /\+/g,  // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
          decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
          query  = window.location.search.substring(1);

      urlParams = {};
      while (match = search.exec(query))
         urlParams[decode(match[1])] = decode(match[2]);
  })();
  
  if (urlParams['customer_posted'] === 'true') {
    $('.sign-up-success-message').show().html("Thanks for joining! Keep an eye on your email.").css('color', '#4c8abd');
  }
  else if(urlParams['customer_posted']  === 'false') {
  	$('.sign-up-success-message').show().html("Please use a valid email address.").css('color', 'red');
  }
  
  // Video Player For Overview Page
  if (window.location.pathname == '/') {
 
    var link = document.getElementById(videoLink);
    var plyrInstnace = new Plyr('#ytplayer');    
    $(link).on('click', function(event) {
		event.preventDefault();
        $('body').addClass('stop-scrolling');
        $('body').bind('touchmove', function(e){e.preventDefault()})
        $('#lightbox').fadeIn().css("display","inline-block");
        plyrInstnace.togglePlay()    
    })
	
    // Video Close Button
    $(closeLink).on('click', function(event) {  
		document.getElementById('content').querySelector( 'iframe').contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        $('body').removeClass('stop-scrolling');
        $('body').unbind('touchmove')
        $('#lightbox').css("display","none");   
        $('.site-footer__linklist').css("top", "70px !important")
        plyrInstnace.pause() 
    })
    
  }
  
  
  /////
  // Technology Page Animations 
  /////

  if (window.location.pathname == '/pages/technology') {
    
    var plyrInstanceVideo = new Plyr('#myVideo')

    window.addEventListener('scroll', function(e) {
      last_known_scroll_position = window.scrollY;
      if (!tickingTech) {
        window.requestAnimationFrame(function() {
          doThisStuffOnScroll(last_known_scroll_position)
          tickingTech = false;
        });
        tickingTech = true;
      }

    });       

    var selector = $('#top');
    var selector2 = $('#top-crypto');
    var selectorVideo = $(".custom__item--1518734920150-1");

    if (isMobile.matches) {
      selector = $('#top-mobile')
      selector2 = $('#top-crypto-mobile')
    }

    var _window = $(window)
    

    function doThisStuffOnScroll() {
      if (selector.offset()) {
        var top_of_element = selector.offset().top;
        var bottom_of_element = selector.offset().top + selector.outerHeight();
        var bottom_of_screen = _window.scrollTop() + window.innerHeight;
        var top_of_screen = _window.scrollTop();
        if((bottom_of_screen - 475 > top_of_element) && (top_of_screen < bottom_of_element)){
          // The element is visible, do something           
          selector.fadeTo( 1500 , 0, function() {
            $('.trans-img-1').css({'z-index': 'unset'})
            // Animation complete.
          });
        }   
      }

      if (selector2.offset()) {
        var top_of_element = selector2.offset().top;
        var bottom_of_element = selector2.offset().top + selector2.outerHeight();
        var bottom_of_screen = _window.scrollTop() + window.innerHeight;
        var top_of_screen = _window.scrollTop();

        if((bottom_of_screen - 355 > top_of_element) && (top_of_screen < bottom_of_element)){
          // The element is visible, do something
          selector2.fadeTo( 1500 , 0, function() {
            // Animation complete.
          });
        }    
      }    

      if (selectorVideo.offset()) {
        var top_of_element = selectorVideo.offset().top;
        var bottom_of_element = selectorVideo.offset().top + selectorVideo.outerHeight();
        var bottom_of_screen = _window.scrollTop() + window.innerHeight;
        var top_of_screen = _window.scrollTop();

        if((bottom_of_screen - 375 > top_of_element) && (top_of_screen < bottom_of_element) && !played){
          // The element is visible, do something
          
          plyrInstanceVideo.muted = true
          plyrInstanceVideo.volume = 0 
          
          plyrInstanceVideo.play();          
          played = true

        }  
      }
      
    }

  }
  
  // Specs hide/show animation
  var extendedSpecs = $('.specs-btn-1')
  var extendedSpecsSpan = $('.specs-btn-1 span')
  var moreSpecs = $('.more-specs-table')
  extendedSpecs.on("click", function(event) {
    extendedSpecsSpan.text('SHOW LESS SPECS')
    if (moreSpecs.hasClass("show")) {
        extendedSpecsSpan.text('SHOW MORE SPECS')
      	moreSpecs.slideUp().toggleClass("show")
    }
    else {
    	moreSpecs.slideDown().toggleClass("show")
    }
	
  })

  var extendedSpecs2 = $('.specs-btn-2')
  var extendedSpecsSpan2 = $('.specs-btn-2 span')
  var moreSpecs2 = $('.more-specs-table')
  extendedSpecs2.on("click", function(event) {
    extendedSpecsSpan2.text('SHOW LESS SPECS')
    if (moreSpecs2.hasClass("show")) {
        extendedSpecsSpan2.text('SHOW MORE SPECS')
        moreSpecs2.slideUp().toggleClass("show")
    }
    else {
      moreSpecs2.slideDown().toggleClass("show")
    }
  
  })

  
  // Initial set submission button as disabled
  $("#subscription-plan-selector input[type='radio']").change(function() {
    $("#subscribe-btn").removeAttr("disabled");
    $("#subscribe-btn").removeClass("disabled");
    
  });    


  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }

    waitForElm('.shopify-challenge__message').then((elm) => {
      $(".shopify-challenge__message").replaceWith("<h1 id='capcha-title' style='font-weight: normal; font-size: 14px; text-align: center'>To continue, let us know you are not a robot</h1>")
  
    });
  
  
//////
// init end
//////
}


function copyReferralLink(idToCopy, selectorToChange, optionalURL) {
  var input = document.getElementById(idToCopy);
  //Get text field mobile
  if (isMobile.matches) {
		var editable = input.contentEditable;
		var readOnly = input.readOnly;

		input.contentEditable = true;
		input.readOnly = false;

		var range = document.createRange();
		range.selectNodeContents(input);

		var selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);

		input.setSelectionRange(0, 999999);
		input.contentEditable = editable;
		input.readOnly = readOnly;  
    
        document.execCommand("copy");
        $(selectorToChange).text('Copied!') 

  }
  else {
    // Get the text field on desktop
    if (!optionalURL) {
      input.select();  
      document.execCommand("copy");
      $(selectorToChange).text('Copied!')    
    }
    else {
      navigator.clipboard.writeText(optionalURL)
      document.execCommand("copy");
      $(selectorToChange).text('Done!')    
    }  
  }
 

}

// FAQ expanders
//TODO: are we still using this? I think we can remove
var expandFaq = function(obj, event) {
  var className = obj.className
  var icons = obj.children;
  for (var i = 0; i < icons.length; i++) { 
    if (icons[i].tagName == 'IMG') {
      if (icons[i].src.includes('line.svg') ) {
        icons[i].src = "//mikucare.com/cdn/shop/t/246/assets/plus.svg?v=173670850200965874021773346905"        
      }
      else {
        icons[i].src = "//mikucare.com/cdn/shop/t/246/assets/line.svg?v=139691355814190087651773346868"      
      }
    }
    
    if (icons[i].tagName == 'DIV') {
      if (icons[i].className == 'support-faq-opened-details') {
        icons[i].setAttribute("class",'support-faq-closed-details');  	
      }
      else {
      	icons[i].setAttribute("class",'support-faq-opened-details');  	
      }    
    }
  }
  
  if (className == 'support-faq-rectangle-opened') {
  	obj.setAttribute("class",'support-faq-rectangle');
  }
  if (className == 'support-faq-rectangle') {
  	obj.setAttribute("class",'support-faq-rectangle-opened');
  }
    

}




function loadIframe(iframeName, url) {
    var $iframe = $('.' + iframeName);
    if ( $iframe.length ) {
        $iframe.attr('src',url);   
        return false;
    }
    return true;
}


var plyrInstanceHeroVideo = new Plyr('#hero-video-elem')
// Function to reveal lightbox and play video
function revealHeroVideo(div,video_id) {
  plyrInstanceHeroVideo.volume = 0.5
  $('.main-content').css({opacity: '.1'})
  $('#shopify-section-header').css({opacity: '.1'})
  $('footer').css({opacity: '1'})  
  document.getElementById(div).style.display = 'block';
  loadIframe('miku-video-src', "https://www.youtube-nocookie.com/embed/" + video_id + "?origin=https://mikucare.com&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1")  
  plyrInstanceHeroVideo.play()

}

// Hiding the lightbox and pause video
function hideHeroVideo(div,video_id) {
  $('.main-content').css({opacity: '1'})
  $('#shopify-section-header').css({opacity: '1'})  
  $('footer').css({opacity: '1'})
  document.getElementById(div).style.display = 'none';
  plyrInstanceHeroVideo.pause()
}   


// Run Init Function On Page Load
function ready() {
  init(); 
}

// Only load hero text after page load. helps with video loading and juming text.
$(window).bind("load", function() { 
	$('.hero-text').fadeIn('slow')            
});


// Wait for document to load
document.addEventListener("DOMContentLoaded", ready);

